var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercarddisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    opacity: 0.259,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6272 9.77942H22.3423V30.2207H33.6272V9.77942Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0589 20C23.0571 18.0314 23.4997 16.0881 24.3531 14.3174C25.2065 12.5467 26.4484 10.9948 27.9848 9.77941C26.0822 8.272 23.7973 7.33456 21.3911 7.07425C18.9849 6.81393 16.5547 7.24123 14.3781 8.30733C12.2015 9.37342 10.3663 11.0353 9.08242 13.103C7.79853 15.1707 7.11768 17.5607 7.11768 20C7.11768 22.4393 7.79853 24.8294 9.08242 26.8971C10.3663 28.9648 12.2015 30.6267 14.3781 31.6927C16.5547 32.7588 18.9849 33.1861 21.3911 32.9258C23.7973 32.6655 26.0822 31.7281 27.9848 30.2207C26.4484 29.0052 25.2065 27.4534 24.3531 25.6827C23.4997 23.9119 23.0571 21.9687 23.0589 20Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8509 20C48.8509 22.4393 48.1702 24.8294 46.8863 26.897C45.6025 28.9647 43.7674 30.6266 41.5909 31.6927C39.4143 32.7588 36.9841 33.1861 34.5779 32.9258C32.1718 32.6655 29.8869 31.7281 27.9844 30.2207C29.5194 29.004 30.7603 27.4519 31.6136 25.6815C32.4669 23.911 32.9103 21.9684 32.9103 20C32.9103 18.0317 32.4669 16.0891 31.6136 14.3186C30.7603 12.5481 29.5194 10.9961 27.9844 9.77941C29.8869 8.27199 32.1718 7.33456 34.5779 7.07424C36.9841 6.81393 39.4143 7.24125 41.5909 8.30736C43.7674 9.37346 45.6025 11.0353 46.8863 13.103C48.1702 15.1707 48.8509 17.5608 48.8509 20Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6208 28.0556V27.6371H47.7882V27.5519H47.3618V27.6371H47.5293V28.0556H47.6208ZM48.4485 28.0556V27.551H48.3178L48.1675 27.8981L48.0171 27.551H47.8864V28.0556H47.9787V27.675L48.1196 28.0031H48.2153L48.3563 27.6742V28.0556H48.4485Z",
    fill: "#F79E1B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercarddisabled);
export default __webpack_public_path__ + "static/media/mastercarddisabled.6ad47f5ad867119866d16050eaf20e43.svg";
export { ForwardRef as ReactComponent };